<template>
  <div class="n8n-instagram-posts-history">
    <b-card>
      <h3 class="mb-3">
        {{ $t('menu.n8n-instagram-history') }}
      </h3>
      <ok-table
        ref="datatable"
        :config="config"
        class="n8n-instagram-posts-history-table"
        @delete="handleDelete"
      >
        <template
          slot="status-column"
          slot-scope="{ props }"
        >
          <b-badge :variant="getStatusVariant(props.row.status)">
            {{ $t(`n8n.${props.row.status}`) }}
          </b-badge>
        </template>
        <template
          slot="error-column"
          slot-scope="{ props }"
        >
          <span v-if="props.row.error">{{ props.row.error }}</span>
          <span v-else>-</span>
        </template>
      </ok-table>
    </b-card>
  </div>
</template>

<script>
import { BBadge, BCard } from 'bootstrap-vue'
import OkTable from '@/@bya3/components/tables/ok-table/OkTable'
import N8nInstagramAccountsApi from '@/api/n8n-instagram-accounts'
import N8nInstagramPostsHistoryTableConfig from './config/n8n-instagram-posts-history-table-config'

export default {
  name: 'N8nInstagramPostsHistoryTable',
  components: {
    BCard,
    BBadge,
    OkTable,
  },
  data() {
    return {
      config: N8nInstagramPostsHistoryTableConfig,
    }
  },
  methods: {
    refreshTable() {
      this.$refs.datatable.loadItems()
    },
    getStatusVariant(status) {
      switch (status) {
        case 'completed':
          return 'success'
        case 'failed':
          return 'danger'
        case 'pending':
        default:
          return 'warning'
      }
    },
    handleDelete(props) {
      this.$okConfirm(this.$t('n8n.history-delete-confirm'), {
        preConfirm: () => N8nInstagramAccountsApi.deleteN8nInstagramAccountHistory(props.row.id)
          .then(() => {
            this.$notifySuccess(this.$t('n8n.history-deleted-successfully'))
            this.refreshTable()
          })
          .catch(e => this.$notifyError(e)),
      })
    },
  },
}
</script>
